import React, { useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import { restaurantProfileDetails, updateRestaurantProfile } from "../../../services/profile.services";
import Swal from "sweetalert2";
import { LOADER_TIMEOUT_TIME, ROLE, SWAL_SETTINGS} from "../../../../../utils/Constants";
import { useValidationSchemas } from "../../../validator/validation";
import { getDateWithTime, getUser, handleServerValidations } from "../../../../../utils/commonfunction";
import { useTranslation } from "react-i18next";
import { DatePicker  } from "rsuite";
import CustomError from "../../../../../utils/customError";
import Skeleton from "react-loading-skeleton";
import { QRCodeSVG } from "qrcode.react";
import ReactToPrint from "react-to-print";
import GoogleAddressInput from "../../../../admin/pages/usermgmt/cafeAddressField";
import { useParams } from "react-router-dom";

export default function RestaurantProfile() {
  const { restaurantProfileValidationSchema, CashierPasswordValidationSchema } = useValidationSchemas();
  const fileSelectInput = useRef();
  const componentRef = useRef();
  const printRef = useRef();
  const { t } = useTranslation();
  const [loader, setLoader] = useState(false);
  const [profileSubmissionform, setProfileSubmissionForm] = useState(false);

  const profileForm = useFormik({
    initialValues: {
      restaurantId: "",
      restaurantName: "", restaurantAddress: "", city: "", zipCode: "",
      website: "",
      cuisineType: "",
      openingTime: "",
      closingTime: "",
      restaurant_logo: "",
      address : ""
    },
    enableReinitialize: true,
    validationSchema: restaurantProfileValidationSchema,
    onSubmit: (values) => {
      const formData = new FormData();
      formData.append("restaurant_name", values.restaurantName);
      formData.append("address", values.address);
      formData.append("restaurant_city", values.city);
      formData.append("restaurant_zip_code", values.zipCode);
      formData.append("restaurant_website", values.website);
      formData.append("restaurant_opening_time", values.openingTime);
      formData.append("restaurant_closing_time", values.closingTime);
      formData.append("restaurant_logo", values.restaurant_logo);
      formData.append("restaurant_address", values.restaurantAddress);
      setProfileSubmissionForm(true);
      updateRestaurantProfile(formData)
        .then((response) => {
          setProfileSubmissionForm(false);
          if (response.success) {
            Swal.fire({
              icon: "success",
              text: response.message,
              ...SWAL_SETTINGS,
            });
          } else {
            Swal.fire({
              icon: "error",
              text: handleServerValidations(response),
              ...SWAL_SETTINGS,
            });
          }
        })
        .catch((error) => {
          setProfileSubmissionForm(false);
          console.error("Error updating profile", error);
        });
      console.log(values);
    },
  });

  

  useEffect(() => {
    const userId = getUser(ROLE.RESTAURANT)?._id;
    // console.log("----555",userId)
    setLoader(true);
    restaurantProfileDetails({ o_id: userId }, userId)
      .then((data) => {
        setTimeout(() => {
          setLoader(false);
        }, LOADER_TIMEOUT_TIME);
        profileForm.setValues({
          restaurantId: data?.data?.id || "",
          restaurantName: data?.data?.cafe_name || "",
          restaurantAddress: data?.data?.restaurant_address || "",
          city: data?.data?.restaurant_city || "",
          zipCode: data?.data?.restaurant_zip_code || "",
          website: data?.data?.restaurant_website || "",
          cuisineType: data?.data?.cuisine_type || "",
          openingTime: data?.data?.restaurant_opening_time || "",
          closingTime: data?.data?.restaurant_closing_time || "",
          restaurant_logo: data?.data?.cafe_logo || "",
          address: data?.data?.address|| "",
        });
        // formFiscalSettings.setValues({
        //   fiscal_year_setting: data?.data?.restaurant_settings?.fiscal_year_setting || "",
        // });
        // formCashier.setValues({
        //   is_cashier_password_updated: data?.data?.is_cashier_password_updated,
        // });
      })
      .catch((err) => {
        setTimeout(() => {
          setLoader(false);
        }, LOADER_TIMEOUT_TIME);
        console.log(err);
      });
  }, []);

  const handleFileSelection = (event) => {
    if (event.target.files.length) {
      profileForm.setFieldValue("restaurant_logo", event.target.files[0]);
    }
  };
  const handleFilePreview = (file) => {
    if (typeof file === "string") {
      return file;
    } else {
      return URL.createObjectURL(file);
    }
  };

  const generateQRUrl = () => {
    const userId = getUser(ROLE.RESTAURANT)?._id;
    let url = `${process.env.REACT_APP_WEB_BASE_URL}/qr-order/table-select/restaurant_id=${userId}`;
    console.log("url", url);
    return url;
  };


  return (
    <>
      <main id="main-content">
        <div className="inner-container">
          <div className="page-header d-flex align-items-center">
            <h4 className="heading-title-text">{t("restaurant.cafe_profile.link_restaurant_profile")}</h4>
          </div>
          <div className="card">
            <div className="card-body">
              {loader ? (
                <div className="">
                  <Skeleton circle={true} style={{ width: "96px", height: "96px" }} />
                  <Skeleton className="mt-4" style={{ height: "30px" }} />
                  <Skeleton className="mt-4" style={{ height: "30px" }} />
                  <Skeleton className="mt-4" style={{ height: "30px" }} />
                  <Skeleton className="mt-4" style={{ height: "30px" }} />
                  <Skeleton className="mt-4" style={{ height: "30px" }} />
                  <Skeleton className="mt-4" style={{ height: "30px" }} />
                </div>
              ) : (
                <form onSubmit={profileForm.handleSubmit}>
                  <div className="d-flex align-items-center justify-content-between py-2" style={{ height: "16rem" }}>
                    <div className="profile-photo-upload mb-3">
                      <div className="avatar avatar-xl">
                        <img alt="cafe_logo" src={handleFilePreview(profileForm?.values?.restaurant_logo)} />
                        {console.log("****", profileForm.values)}
                      </div>
                      <button
                        className="cp e_none"
                        type="button"
                        onClick={() => {
                          fileSelectInput?.current?.click();
                        }}>
                        <input ref={fileSelectInput} id="restaurant_logo" name="restaurant_logo" accept="image/*" type="file" onChange={handleFileSelection} />
                        <i className="ti ti-upload"></i>
                      </button>
                    </div>
                    <CustomError name="restaurant_logo" form={profileForm} className="text-danger my-3" />


                    <div style={{gap : "52px"}} className="mx-5 d-flex flex-column align-items-center justify-content-between">
                      <div className="qr-code mb-3" ref={printRef}>
                        <figure
                            className="qr-code-img"
                            onClick={(e) => {
                              if (e.ctrlKey || e.metaKey) {
                                window.open(generateQRUrl(), "_blank");
                              }
                            }}
                          >
                          <QRCodeSVG value={generateQRUrl()} id="qr-image" />
                        </figure>
                      </div>

                      {/* <span
                        style={{ width: "6rem", marginTop: "2rem" }}
                        className="btn btn-primary"
                        onClick={handlePrint}
                      >
                        <i className="ti ti-printer"></i> Print
                      </span> */}
                      <ReactToPrint
                        trigger={() => (
                          <button type="button" style={{ width: "6rem", marginTop: "2rem" }} className="btn btn-primary w-100">
                            <i className="ti ti-printer"></i>
                            {t("Print")}
                          </button>
                        )}
                        content={() => componentRef.current}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">
                          {/* {t("restaurant_id")} */}
                          {t("restaurant.cafe_profile.restaurant_id")}
                          <span>*</span>
                        </label>
                        <input type="text" className="form-control" disabled value={profileForm.values.restaurantId} />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">
                          {/* {t("label_restaurant_name")} */}
                          {t("restaurant.cafe_profile.label_cafe_name")}
                          <span>*</span>
                        </label>
                        <input type="text" className="form-control" name="restaurantName" placeholder="Enter Trade name" onChange={profileForm.handleChange} value={profileForm.values.restaurantName} />
                        {/* {profileForm.errors.restaurantName ? <div className="text-danger">{profileForm.errors.restaurantName}</div> : null} */}
                        <CustomError name="restaurantName" form={profileForm} className="text-danger" />
                      </div>
                    </div>

                    <GoogleAddressInput formik={profileForm} name={"restaurantAddress"} t={t} />

                    <div className="col-md-6">
                      <div className="mb-3 input-address">
                        <label className="form-label">
                          {t("restaurant.cafe_profile.label_restaurant_address")}
                          <span>*</span>
                        </label>
                        <input type="text" className="form-control" name="address" placeholder="Enter Trade address" onChange={profileForm.handleChange} value={profileForm.values.address} />
                        {/* {profileForm.errors.restaurantAddress ? <div className="text-danger">{profileForm.errors.restaurantAddress}</div> : null} */}
                        <CustomError name="address" form={profileForm} className="text-danger" />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">
                              {t("restaurant.cafe_profile.label_city")}
                              <span>*</span>
                            </label>
                            <input type="text" className="form-control" name="city" placeholder="Enter city" onChange={profileForm.handleChange} value={profileForm.values.city} />
                            {/* {profileForm.errors.city ? <div className="text-danger">{profileForm.errors.city}</div> : null} */}
                            <CustomError name="city" form={profileForm} className="text-danger" />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">
                              {t("restaurant.cafe_profile.zip_code")}
                              <span>*</span>
                            </label>
                            <input type="number" className="form-control no_spring_input" name="zipCode" placeholder="Enter postcode" onChange={profileForm.handleChange} value={profileForm.values.zipCode} />
                            {/* {profileForm.errors.zipCode ? <div className="text-danger">{profileForm.errors.zipCode}</div> : null} */}
                            <CustomError name="zipCode" form={profileForm} className="text-danger" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">
                          {t("restaurant.cafe_profile.label_website")}
                          <span></span>
                        </label>
                        <input type="text" className="form-control" name="website" placeholder="Enter website" onChange={profileForm.handleChange} value={profileForm.values.website} />
                        {/* {profileForm.errors.website ? <div className="text-danger">{profileForm.errors.website}</div> : null} */}
                        <CustomError name="website" form={profileForm} className="text-danger" />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="row">
                        <div className="col-md-12">
                          <label className="form-label">
                            {/* {t("restaurant_time")} */}
                            {t("restaurant.cafe_profile.cafe_time")}
                            <span>*</span>
                          </label>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <DatePicker
                              classPrefix="restaurant"
                              placement="autoVertical"
                              format="HH:mm"
                              cleanable={false}
                              editable={true}
                              name="openingTime"
                              onChange={(e) => {
                                profileForm.setFieldTouched("openingTime", true);
                                const match = String(e).match(/\d{2}:\d{2}:\d{2}/);
                                if (match) {
                                  const [hours, minutes] = match[0].split(":");
                                  profileForm.setFieldValue("openingTime", `${hours}:${minutes}:00`);
                                }
                              }}
                              value={getDateWithTime(profileForm.values.openingTime)}
                              onBlur={profileForm.handleBlur}
                            />
                            <CustomError name="openingTime" form={profileForm} className="text-danger" />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <DatePicker
                              classPrefix="restaurant"
                              placement="autoVertical"
                              format="HH:mm"
                              cleanable={false}
                              editable={true}
                              name="closingTime"
                              onChange={(e) => {
                                profileForm.setFieldTouched("closingTime", true);
                                const match = String(e).match(/\d{2}:\d{2}:\d{2}/);
                                // profileForm.setFieldValue("closingTime", String(match[0]));
                                if (match) {
                                  const [hours, minutes] = match[0].split(":");
                                  profileForm.setFieldValue("closingTime", `${hours}:${minutes}:00`);
                                }
                              }}
                              value={getDateWithTime(profileForm.values.closingTime)}
                            />

                            <CustomError name="closingTime" form={profileForm} className="text-danger" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="button-form">
                    <button type="submit" className={"btn btn-primary" + (profileSubmissionform ? " btn-loader" : "")}>
                      {t("restaurant.cafe_profile.btn_update_profile")}
                    </button>
                  </div>
                </form>
              )}
            </div>
          </div>
        </div>
      </main>

      <div style={{ display: "none" }}>
        <div ref={componentRef} className="container d-flex justify-content-center align-items-center vh-100">
          <div className="text-center">
            <QRCodeSVG value={profileForm?.values?.restaurantId} height={400} width={400} className="mt-4" />
          </div>
        </div>
      </div>
    </>
  );
}
